import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface emailCountState {
  emailCount: any
}

const initialState: emailCountState = {
  emailCount: null,
}

const emailCountSlice = createSlice({
  name: "emailCount",
  initialState,
  reducers: {
    setEmailCount(state, action: PayloadAction<any>) {
      state.emailCount = action.payload
    },
  },
})

export const { setEmailCount } = emailCountSlice.actions
export default emailCountSlice.reducer
